import type { PageRealizationSnapshot } from './inventory-page-health';

export function realizationGapSortValue(
  realization: PageRealizationSnapshot | null | undefined
): number {
  if (!realization || realization.gapGate !== 'scored') return Number.NEGATIVE_INFINITY;
  const gap = realization.gap;
  return Number.isFinite(gap) ? Number(gap) : Number.NEGATIVE_INFINITY;
}

export function realizationRatioSortValue(
  realization: PageRealizationSnapshot | null | undefined
): number {
  if (!realization || realization.gapGate !== 'scored') return Number.POSITIVE_INFINITY;
  const ratio = realization.realizationRatio;
  return Number.isFinite(ratio) ? Number(ratio) : Number.POSITIVE_INFINITY;
}

export function formatInventoryRealizationNumber(value: number | null | undefined): string {
  if (!Number.isFinite(value)) return '—';
  return Number(value).toFixed(1);
}

export function formatInventoryRealizationRatio(value: number | null | undefined): string {
  if (!Number.isFinite(value)) return '—';
  return Number(value).toFixed(2);
}

export function inventoryRealizationGapTitle(
  realization: PageRealizationSnapshot | null | undefined
): string {
  if (!realization) return 'No realization data';
  if (realization.gapGate !== 'scored') {
    return `Not scored (${realization.gapGate}). Run demand labeling and ranked keywords for this URL.`;
  }
  const parts = [
    `Gap ${formatInventoryRealizationNumber(realization.gap)}`,
    `realized ${formatInventoryRealizationNumber(realization.realizedVisibility)}`,
    `ceiling ${formatInventoryRealizationNumber(realization.ceiling)}`
  ];
  const driver = realization.ceilingDriver?.keyword?.trim();
  if (driver) parts.push(`ceiling driver: ${driver}`);
  return parts.join(' · ');
}

/** Sort value for SERP keyword difficulty; rows without SERP/KD sort last. */
export function serpKeywordDifficultySortValue(
  difficulty: number | null | undefined
): number {
  if (!Number.isFinite(difficulty)) return Number.POSITIVE_INFINITY;
  return Number(difficulty);
}

export function inventoryRealizationRatioTitle(
  realization: PageRealizationSnapshot | null | undefined
): string {
  if (!realization) return 'No realization data';
  if (realization.gapGate !== 'scored') {
    return `Not scored (${realization.gapGate}). Ratio applies only when demand gap is scored.`;
  }
  return `Realization ratio ${formatInventoryRealizationRatio(realization.realizationRatio)} (realized ÷ ceiling)`;
}
